import * as React from "react";

export const ProductAvailableIcon = (props: { color: string }) => (
  <svg
    width={15}
    height={9}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m7.235 6.173.941.942L13.82 1.47l.943.942L8.176 9 3.933 4.757l.943-.942L6.293 5.23l.942.942Zm.001-1.885L10.537.986l.94.94-3.301 3.302-.94-.94Zm-1.885 3.77L4.41 9 .167 4.757l.942-.942.942.942 3.3 3.301Z"
      fill={props.color}
    />
  </svg>
);
